import { render } from "./ListeInventairePage.vue?vue&type=template&id=5345de7e&ts=true"
import script from "./ListeInventairePage.vue?vue&type=script&lang=ts"
export * from "./ListeInventairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__